const paths = {
  home: '/',
  MGquestionnaire: '/medicare-supplement/questionnaire',
  MAquestionnaire: '/medicare-advantage/questionnaire',
  resultsType: '/type',
  zip: '/zip',
};

export default paths;
